import { render, staticRenderFns } from "./cohort.vue?vue&type=template&id=1bf9e3c4&"
import script from "./cohort.vue?vue&type=script&lang=js&"
export * from "./cohort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bf9e3c4')) {
      api.createRecord('1bf9e3c4', component.options)
    } else {
      api.reload('1bf9e3c4', component.options)
    }
    module.hot.accept("./cohort.vue?vue&type=template&id=1bf9e3c4&", function () {
      api.rerender('1bf9e3c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/beneficiary/cohort.vue"
export default component.exports